<template>
  <div class="item">
      <div class="item-top">
          <div class="item-top_left">{{productItem.name}}</div>
          <img class="item-top_right" :src="productItem.bankLogo"/>
      </div>
      <div class="item-middle">
          <div class="item-box">
              <div class="range" v-if="productItem.annualInterestRangeStart && productItem.annualInterestRangeEnd">{{productItem.annualInterestRangeStart}}-{{productItem.annualInterestRangeEnd}}<span>%</span></div>
              <div class="range" v-else-if="productItem.annualInterestRangeStart"><span>不低于</span>{{productItem.annualInterestRangeStart}}<span>%</span></div>
              <div class="range" v-else><span>不高于</span>{{productItem.annualInterestRangeEnd}}<span>%</span></div>
              <div class="text">年息范围</div>
          </div>
          <div class="item-box">
              <div class="range">{{productItem.quotaRangeEnd}}<span>万元及以下</span></div>
              <div class="text">额度范围</div>
          </div>
          <div class="">
              <div class="range">{{productItem.acceptanceTimeStart}}-{{productItem.acceptanceTimeEnd}}<span>个工作日</span></div>
              <div class="text">审批时间</div>
          </div>
      </div>
      <div class="item-bottom" v-if="productItem.labelList">
          <div 
            v-for="(tagName,index) in productItem.labelList" 
            :key="index"
            :class="tagItemClass(tagName)">
                {{tagName}}
            </div>
      </div>
      <div class="item-bottom" v-else>
            <div></div>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        productItem: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        tagItemClass (tagName) {
            return [
                tagName == '抗疫专项产品'
                    ? 'tag__item-green'
                    : ''
            ]
        }
    }
}
</script>

<style scoped>
.item {
    height: 120px;
    box-sizing: border-box;
    padding: 12px 12px 0;
    cursor:pointer
}
.item:hover{
    background-color: #F6FBFF;
}
.item-top {
    line-height: 22px;
    color: #333333;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    justify-content: space-between ;
    margin-bottom: 9px;
}
.item-top_left {
    margin-left: 15px;
}
.item-top_right {
    height: 18px;
}

.item-middle {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
}
.item-box {
    width: 35%;
}
.item-middle .range {
    display: inline-block;
    line-height: 18px;
    color: #FF4C00;
    font-size: 21px;
    font-weight: 600;
    margin-bottom:5px;
}
.item-middle .range span{
    font-size: 12px;
    font-weight: normal;
}
.item-middle .text {
    color: #666;
    font-size: 15px;
    line-height: 15px;
}

.item-bottom{
    margin-top: 6px;
    padding-bottom: 11.5px;
    padding-left: 15px;
    border-bottom: 1px solid #EDF0F3;
}
.item-bottom div{
    line-height: 14px;
    background-color: #E7F1FF;
    display: inline-block;
    color: #1492FF;
    border-radius: 2px;
    font-size: 12px;
    padding: 1px 6px;
    margin-right: 10px;
}
.item-bottom .tag__item-green {
    color:#00B578 ;
    background-color: #E5F7F1;
}
</style>